import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Alert, Button, Flex } from "antd";
import { useNavigate } from "react-router-dom";
import { buildRoutePath } from "tm-shared/utils";

import { ROUTES } from "@/constants";
import { PrimaryText } from "@/shared/ui/Typography";

export const AddressAlertBlock = ({
    marketId,
    pointId,
}: {
    marketId: string;
    pointId: string;
}) => {
    const navigate = useNavigate();

    const goToVerify = () => {
        navigate(
            buildRoutePath(ROUTES.MarketVerifyAddress, {
                marketId,
                pointId,
            }),
        );
    };

    return (
        <Alert
            type="warning"
            showIcon
            icon={<ExclamationCircleOutlined style={{ fontSize: 18 }} />}
            title={
                <Flex align="center" gap={8} wrap="wrap">
                    <PrimaryText fontSize={14}>
                        Адресу не верифіковано.
                    </PrimaryText>
                </Flex>
            }
            action={
                <Button type="primary" onClick={goToVerify}>
                    <PrimaryText textColor="white">Верифікувати</PrimaryText>
                </Button>
            }
            style={{ marginTop: 12 }}
        />
    );
};
